import React, { useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { useTranslation } from "react-i18next";
import {
    INPUT_LENGTH_15,
    PHONE_NO_LENGTH,
    SWAL_SETTINGS,
    TEXTAREA_MAX_LENGTH,
} from "../../../../utils/Constants";
import {
    blockInvalidChar,
    DT,
    globalLoader,
    handleServerValidations,
} from "../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { Add } from "../../services/medicine.services";
import { cuisineOptions } from "../../../../utils/Constants";
import { TagPicker, Tooltip, Whisper } from "rsuite";
import PhoneInput from "../../../../utils/PhoneInput";
import { PHONE_VALIDATION } from "../../../../utils/commonValidations";
import CustomCkeditor from "../../common/customeditor";

const AddMedicine = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [submitted, setSubmitted] = useState(false);
    const [previewimage, setPreviewImage] = useState("");
    const breadcrumbs = [
        { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
        {
            title: t("Medicine Management"),
            url: "/admin/medicine-management/medicine/list/1",
        },
        { title: t("admin.cafes.link_add"), url: "" },
    ];

    const validationSchema = Yup.object().shape({
        name: Yup.string().trim().max(150, "Medicine name must not be more than 150 characters.").required("Medicine name is required"),
        description: Yup.string().trim().required("Description is required"),
        // expiry_date: Yup.date().required("Expiry date is required"),
        // quantity: Yup.string()
        // .transform((value, originalValue) => originalValue ? String(originalValue) : value)
        // .trim()
        // .required("Quantity is required")
        // .test('no-decimal', 'Quantity cannot be a decimal', value => {
        //   return value ? !value.includes('.') : true;
        // })
        // .test('no-negative', 'Quantity cannot be negative', value => {
        //   return value ? !value.startsWith('-') : true;
        // })
        // .test('max-digits', 'Quantity cannot be more than 10 digits', value => {
        //   return value ? value.length <= 10 : true;
        // })      
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: "",
            description: "",
            // expiry_date: "",
            // quantity: "",
        },
        validateOnBlur: false,
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting, resetForm }) => {
            globalLoader(true);
            setSubmitted(true);
            let formData = new FormData();
            formData.append("name", values.name);
            formData.append("description", values.description);
            // formData.append("expiry_date", values.expiry_date);
            // formData.append("quantity", values.quantity);
            Add(formData)
                .then((response) => {
                    setSubmitting(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                        resetForm({ values: "" });
                        navigate(`/admin/medicine-management/medicine/list/1`);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                        setSubmitted(false);
                    }
                })
                .catch((error) => {
                    console.log("error ====> ", error);
                });
        },
    });

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <form onSubmit={formik.handleSubmit}>
                <div className="row row-sm">
                    <div className="col-lg-12 col-md-12 animation_fade">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div>
                                    <h6 className="main-content-label mb-3">
                                        Add Medicine
                                    </h6>
                                </div>
                                <div className="row row-sm">
                                    <div className="col-md-6 text-center form-group">
                                        <label htmlFor="name" className="text-left d-flex">
                                            {t("Medicine Name")}:
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <input
                                            name="name"
                                            id="name"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.name}
                                            className="form-control"
                                            placeholder={t("Enter medicine name")}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError shortCodes={[INPUT_LENGTH_15]} name="name" form={formik} />
                                        </span>
                                    </div>
                                    {/* <div className="col-md-6 text-center form-group">
                                        <label htmlFor="address" className="text-left d-flex">
                                            {t("Quantity")}:
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <input
                                            name="quantity"
                                            id="quantity"
                                            type="number"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.quantity}
                                            className="form-control"
                                            placeholder={t("Enter quantity")}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="quantity" form={formik} />
                                        </span>
                                    </div> */}
                                    {/* <div className="col-md-6 text-center form-group">
                                        <label htmlFor="address" className="text-left d-flex">
                                            {t("Expiry Date")}:
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <input
                                            name="expiry_date"
                                            id="expiry_date"
                                            type="date"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.expiry_date}
                                            className="form-control"
                                            placeholder={t("Enter location")}
                                            min={new Date().toISOString().split("T")[0]}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="expiry_date" form={formik} />
                                        </span>
                                    </div> */}
                                    <div className="col-lg-12 text-center form-group">
                                        <label htmlFor="subject" className="text-left d-flex">
                                            {t("Description")}:<span className="requirestar">*</span>
                                        </label>
                                        <CustomCkeditor
                                            fieldname={"description"}
                                            setFieldValue={formik.setFieldValue}
                                            value={formik.values.richtext}
                                            setFieldTouched={formik.setFieldTouched}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="description" form={formik} />
                                        </span>
                                    </div>
                                    <div className="mt-5">
                                        <button
                                            className="btn btn-info mr-2"
                                            type="submit"
                                            disabled={submitted ? true : null}
                                        >
                                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                            {t("admin.button.btn_submit")}
                                        </button>
                                        <button
                                            className="btn ripple btn-secondary"
                                            type="button"
                                            disabled={submitted ? true : null}
                                            onClick={() => navigate(-1)}
                                        >
                                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                            {t("admin.button.btn_cancel")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default AddMedicine;